import React, { useState } from "react";

const Deduction = ({ taxList, deductionList, setDeductionList, handleSDRefund, setTransectionData }) => {
    const totalAmount = deductionList.reduce((sum, item) => sum + parseFloat(item.amount || 0), 0).toFixed(3);
    const totalVat = deductionList.reduce((sum, item) => sum + parseFloat(item.vat || 0), 0).toFixed(3);
    const totalQty = deductionList.reduce((sum, item) => sum + parseFloat(item.qty || 0), 0).toFixed(3);
    const totalrate = deductionList.reduce((sum, item) => sum + parseFloat(item.rate || 0), 0).toFixed(3);
    const total = deductionList.reduce((sum, item) => sum + parseFloat(item.total || 0), 0).toFixed(3);
    const [selectedIndex, setSelectedIndex] = useState(null);

    const handleChange = (index, key, value) => {
        const updatedList = [...deductionList];
        updatedList[index][key] = value;

        const rate = parseFloat(updatedList[index].rate) || 0;
        const qty = parseFloat(updatedList[index].qty) || 0;
        const amount = rate * qty;

        // find selected tax record
        const selectedTax = taxList.find((t) => t.RecordId === parseInt(updatedList[index].TaxCode));
        const taxRate = selectedTax ? parseFloat(selectedTax.Rate) : 0;
        const vat = ((taxRate / 100) * amount) || 0;

        updatedList[index].amount = amount.toFixed(3);
        updatedList[index].Percentage = taxRate;
        updatedList[index].vat = vat.toFixed(3);
        updatedList[index].total = (amount + vat).toFixed(3);
        updatedList[index].VatAccCode = selectedTax;

        setDeductionList(updatedList);
    };

    const preventNegativeSign = (e) => {
        if (e.key === "-" || e.key === "+") {
            e.preventDefault();
        }
    };
    return (
        <div className='gridshad mt-2 mb-3'>
            <div className='table-container' style={{ overflowX: 'auto', height: "auto" }}>
                <table>
                    <thead className='dynoTable'>
                        <tr>
                            <th>Select</th>
                            <th>Description</th>
                            <th>Rate</th>
                            <th>Qty</th>
                            <th>Amount</th>
                            <th>Tax Code</th>
                            <th>Vat</th>
                            <th>Total</th>
                            <th>Posting</th>
                            <th>Remarks</th>
                            <th>from Rent</th>
                        </tr>
                    </thead>
                    <tbody>
                        {Array.isArray(deductionList) &&
                            deductionList.map((data, index) => {
                                const isSelected = data?.Exp3 === "1"; // use Exp3 for selection

                                return (
                                    <tr key={index}>
                                        {/* Select checkbox */}
                                        <td className="m-0 p-0 text-center">
                                            <input
                                                type="checkbox"
                                                checked={isSelected}
                                                onChange={(e) => {
                                                    const updatedList = [...deductionList];
                                                    if (e.target.checked) {
                                                        updatedList[index].Exp3 = "1"; // ✅ checked
                                                    } else {
                                                        updatedList[index].Exp3 = "0"; // ❌ unchecked → clear fields
                                                        updatedList[index].rate = "";
                                                        updatedList[index].qty = "";
                                                        updatedList[index].amount = "0.00";
                                                        updatedList[index].Percentage = "";
                                                        updatedList[index].vat = "0.00";
                                                        updatedList[index].total = "0.00";
                                                    }
                                                    setDeductionList(updatedList);
                                                }}
                                                style={{ width: "20px", height: "20px" }}
                                            />
                                        </td>

                                        {/* Description */}
                                        <td className="m-0 p-0">
                                            <input
                                                className="p-1"
                                                value={data?.Description}
                                                disabled
                                                style={{ width: "300px" }}
                                            />
                                        </td>

                                        {/* Rate */}
                                        <td className="m-0 p-0">
                                            <input
                                                className="p-1"  onKeyDown={preventNegativeSign}
                                                type="number"
                                                style={{ width: "100%" }}
                                                value={data?.rate || ""}
                                                disabled={!isSelected} // ✅ editable only if selected
                                                onChange={(e) => handleChange(index, "rate", e.target.value)}
                                            />
                                        </td>

                                        {/* Qty */}
                                        <td className="m-0 p-0">
                                            <input
                                                className="p-1"  onKeyDown={preventNegativeSign}
                                                type="number"
                                                style={{ width: "100%" }}
                                                value={data?.qty || ""}
                                                disabled={!isSelected} // ✅ editable only if selected
                                                onChange={(e) => handleChange(index, "qty", e.target.value)}
                                            />
                                        </td>

                                        {/* Amount */}
                                        <td className="m-0 p-0">
                                            <input
                                                className="p-1"
                                                value={data?.amount || "0.00"}
                                                disabled
                                                style={{ width: "100%" }}
                                            />
                                        </td>

                                        {/* Tax dropdown */}
                                        <td className="m-0 p-0">
                                            <select
                                                className="p-1"
                                                style={{ width: "100%" }}
                                                value={data?.TaxCode || ""}
                                                disabled={!isSelected} // ✅ editable only if selected
                                                onChange={(e) => handleChange(index, "TaxCode", e.target.value)}
                                            >
                                                <option value="">--Select Tax--</option>
                                                {taxList.map((tax) => (
                                                    <option key={tax.RecordId} value={tax.RecordId}>
                                                        {tax.Description}
                                                    </option>
                                                ))}
                                            </select>
                                        </td>

                                        {/* VAT % */}
                                        <td className="m-0 p-0">
                                            <input
                                                className="p-1"
                                                value={data?.vat || 0}
                                                disabled
                                                style={{ width: "100%" }}
                                            />
                                        </td>

                                        {/* Total */}
                                        <td className="m-0 p-0">
                                            <input
                                                className="p-1"
                                                value={data?.total || "0.00"}
                                                disabled
                                                style={{ width: "100%" }}
                                            />
                                        </td>

                                        {/* Posting */}
                                        <td className="m-0 p-0 text-center">
                                            <input
                                                type="checkbox"
                                                checked={data?.Posting}
                                                onChange={(e) =>
                                                    handleChange(index, "Posting", e.target.checked)
                                                }
                                                style={{ width: "20px", height: "20px" }}
                                            />
                                        </td>

                                        {/* Remarks */}
                                        <td className="m-0 p-0">
                                            <input
                                                className="p-1"
                                                style={{ width: "300px" }}
                                                value={data?.Remarks}
                                                onChange={(e) => handleChange(index, "Remarks", e.target.value)}
                                            />
                                        </td>

                                        {/* From Rent */}
                                        <td className="m-0 p-0 text-center">
                                            <input
                                                type="checkbox"
                                                checked={data?.fromRent || false}
                                                onChange={(e) =>
                                                    handleChange(index, "fromRent", e.target.checked)
                                                }
                                                style={{ width: "20px", height: "20px" }}
                                            />
                                        </td>
                                    </tr>
                                );
                            })}

                        {/* Footer row */}
                        <tr>
                            <td><input className='p-1' type="text" disabled style={{ width: "100%" }} /></td>
                            <td><input className='p-1' type="text" disabled style={{ width: "100%" }} /></td>
                            <td><input className='p-1' type="text" disabled style={{ width: "100%" }} value={totalrate || "0.000"} /></td>
                            <td><input className='p-1' type="text" disabled style={{ width: "100%" }} value={totalQty || "0"} /></td>
                            <td><input className='p-1' type="text" disabled style={{ width: "100%" }} value={totalAmount || "0.000"} /></td>
                            <td><input className='p-1' type="text" disabled style={{ width: "100%" }} /></td>
                            <td><input className='p-1' type="text" disabled style={{ width: "100%" }} value={totalVat || "0.000"} /></td>
                            <td><input className='p-1' type="text" disabled style={{ width: "100%" }} value={total || "0.000"} /></td>
                            <td><input className='p-1' type="text" disabled style={{ width: "100%" }} /></td>
                            <td><input className='p-1' type="text" disabled style={{ width: "100%" }} /></td>
                            <td><input className='p-1' type="text" disabled style={{ width: "100%" }} /></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div >
    );
};

export default Deduction;